<template>
  <div class="lockable-input-wrapper">
    <div class="lockable-input" :class="{locked: locked}">
      <div class="input">
        <slot/>
      </div>
      <div
        v-if="locked"
        class="label label-danger lock-button">
        <i class="fa fa-lock" />
      </div>
    </div>
    <slot name="label" />
    {{ displayValue }}
  </div>
</template>

<script>
export default {
  name: 'LockableInputWrapper',
  props: {
    locked: {
      type: Boolean,
      default: false
    },
    displayValue: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang='less'>
.lockable-input-wrapper{
  display: flex;
  align-items: center;
  margin: 0 0.25rem;

  .lockable-input {
    position: relative;

    .lock-button {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-shadow: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      .fa-lock {
        transform: translateX(4%);
      }
    }

    &.locked {
      .input {
        opacity: 0;
      }
    }
  }
}
</style>
